<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Notas Fiscais</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="actions"></div>

      <div class="table-container">
        <app-loading *ngIf="loading"></app-loading>

        <ng-container *ngIf="!loading">
          <div *ngIf="dataSource.data.length === 0">
            <h3>Nenhuma nota fiscal encontrada</h3>
          </div>

          <table
            mat-table
            [dataSource]="dataSource"
            class="full-width-table"
            *ngIf="dataSource.data.length > 0"
          >
            <ng-container matColumnDef="indicationId">
              <th mat-header-cell *matHeaderCellDef>Indicação</th>
              <td mat-cell *matCellDef="let e">{{ e.indicationId }}</td>
            </ng-container>

            <ng-container matColumnDef="nfeId">
              <th mat-header-cell *matHeaderCellDef>Asaas ID</th>
              <td mat-cell *matCellDef="let e">
                <ng-container *ngIf="e.nfeId; else dash">
                  <a
                    [href]="generateInvoiceLink(e.nfeId!)"
                    target="_blank"
                    rel="noopener"
                    style="text-decoration: none"
                  >
                    {{ e.nfeId }}
                  </a>
                </ng-container>
                <ng-template #dash>-</ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="statusNf">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let e">{{ e.statusNf | titlecase }}</td>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef>Criada em</th>
              <td mat-cell *matCellDef="let e">
                {{ formatDate(e.createdAt) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef>Atualizada em</th>
              <td mat-cell *matCellDef="let e">
                {{ formatDate(e.updatedAt) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Download</th>
              <td mat-cell *matCellDef="let e" class="row-actions">
                <button
                  *ngIf="e.pdfUrl"
                  mat-icon-button
                  class="download-btn"
                  (click)="download(e.pdfUrl)"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>
                <button
                  *ngIf="e.xmlUrl"
                  mat-icon-button
                  class="download-btn"
                  (click)="download(e.xmlUrl)"
                >
                  <mat-icon>code</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="errors">
              <th mat-header-cell *matHeaderCellDef>Erros</th>
              <td mat-cell *matCellDef="let e">
                <button
                  class="error-btn"
                  mat-icon-button
                  (click)="openErrorModal(e)"
                  [disabled]="e.countLogs === 0"
                >
                  <mat-icon>{{ getErrorIcon(e.countLogs) }}</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </ng-container>
      </div>
      <div class="overlay" *ngIf="showErrorModal">
        <div class="modal">
          <h2>Erros da Nota</h2>
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Motivo</th>
                <th>Data/Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let err of modalErrors">
                <td>{{ err.statusCode }}</td>
                <td>{{ err.reason }}</td>
                <td>{{ err.createdAt }}</td>
              </tr>
            </tbody>
          </table>
          <button
            _ngcontent-thy-c153=""
            type="button"
            mat-button=""
            (click)="showErrorModal = false"
            class="mat-focus-indicator btn-cancel mat-button mat-button-base close-btn"
          >
            Fechar
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
